// export function cardGridLinks() {
//   document.querySelectorAll(".pipechain-card-grid__card a").forEach((_el) => {
//     let el = _el as HTMLAnchorElement;
//     el.addEventListener("click", (e) => {
//       e.preventDefault();
//     });
//   });
// }

export function cardGridLinks() {
  document.querySelectorAll(".pipechain-card-grid__card").forEach((_el) => {
    let el = _el as HTMLElement;
    const href = el.dataset.href;
    href &&
      el.addEventListener("click", () => {
        window.location.href = href;
      });
  });
}
